import { jsx as t, jsxs as l, Fragment as C } from "react/jsx-runtime";
import { forwardRef as N, useRef as T, useState as y } from "react";
import { B } from "../checkbox/BaseCheckbox-BGkrjof6.mjs";
const R = N(
  ({ children: a, className: h = "", defaultChecked: c, icons: e, iconClass: i = "", id: b, onChange: s, alwaysShowLabel: f = !1, ...m }, p) => {
    const I = T(null), [n, g] = y(!!c), r = e && "checkedIcon" in e ? e.checkedIcon : null, d = e && "uncheckedIcon" in e ? e.uncheckedIcon : null, u = e && "toggleIcon" in e ? e.toggleIcon : null, o = p || I, k = (x) => {
      var _;
      typeof s == "function" && s(x), g(typeof o != "function" ? !!((_ = o.current) != null && _.checked) : !n);
    };
    return /* @__PURE__ */ t(
      B,
      {
        id: b,
        ref: o,
        dataTestId: "toggle-button__label",
        containerClassName: h + " rds-toggle-button-container",
        inputClassName: "rds-toggle-button__input",
        labelClassName: "rds-toggle-button",
        onChange: k,
        defaultChecked: c,
        ...m,
        children: /* @__PURE__ */ l("span", { className: "rds-toggle-button__content", children: [
          e && /* @__PURE__ */ l(C, { children: [
            /* @__PURE__ */ l("span", { className: `rds-toggle-button__icon ${i}`, children: [
              u && /* @__PURE__ */ t(u, { checked: n }),
              r && n && /* @__PURE__ */ t(r, {}),
              d && !n && /* @__PURE__ */ t(d, {})
            ] }),
            /* @__PURE__ */ t(
              "span",
              {
                "data-testid": "toggle-button__icon__label__text",
                className: `label-text__icon ${f ? "always-show-label" : ""}`,
                children: a
              }
            )
          ] }),
          !e && /* @__PURE__ */ t("span", { "data-testid": "toggle-button__label__text", children: a })
        ] })
      }
    );
  }
);
R.displayName = "ToggleButton";
export {
  R as T
};
